import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FileHandlerService, IFileOptions } from 'src/app/utility/services/file-handler/file-handler.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { FileValidatorService } from '../../service/file-validator/file-validator.service';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';
import { PpoListService } from '../../service/ppo-list/ppo-list.service';
import { IFileExtend } from '../../model/IFileExtend';
import { PPORequestStatus, ValidatorType } from 'src/app/utility/enum/global-enum';
import { ActivatedRoute } from '@angular/router';
import { GroupClaimSubmissionService } from '../../service/group-claim-submission/group-claim-submission.service';
import { AdditonalDocumentSubmissionMessage } from 'src/app/utility/services/message/custom-messages';

@Component({
  selector: 'app-nigo-document-upload-ppo',
  templateUrl: './nigo-document-upload-ppo.component.html',
  styleUrls: ['./nigo-document-upload-ppo.component.scss']
})
export class NigoDocumentUploadPPOComponent implements OnInit {


  fileExtends: IFileExtend[];
  fileExtend: IFileExtend;
  fileOption: IFileOptions = { acctptedTypes: "" };

  claimFormFile: any;
  statusId: PPORequestStatus;

  //Online GM Group Claim Submission variable
  ppoRequestId: number;
  productId: number;
  productName: string;
  enrolId: number;
  enrolDependentId: number;
  claimAmount: number;
  insuranceAmount: number;
  claimForm: IFileExtend;
  claimEntryId: number;
  isDocSubmission = true;
  customMessage = new AdditonalDocumentSubmissionMessage();
  @ViewChild('fileInput', {static: false}) fileInputVariable: ElementRef;

  constructor(
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    private fileValidatorService: FileValidatorService,
    private navigationService: NavigateService,
    private ppoService: PpoListService,
    private activateRoute: ActivatedRoute,
    private groupClaimSubmissionService: GroupClaimSubmissionService,
  ) { }

  ngOnInit() {
    this.ppoRequestId = Number(this.activateRoute.snapshot.paramMap.get('ppoRequestId'));
    this.claimEntryId = Number(this.activateRoute.snapshot.paramMap.get('claimEntryId'));
    this.getNIGODocuments(this.claimEntryId);
  }

  onBackButtonClick() {
    this.navigationService.toPpoRequestList();
  }

  getClaimSubmissionDocumentData() {
    const entity = {
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      productId: this.productId,
      ppoRequestId: this.ppoRequestId,
      claimEntryId: this.claimEntryId
    };
    const formData = this.getFormData(entity);
    return formData;
  }

  onFileChange(event, item: IFileExtend) {
    if (
      event &&
      this.fileHandlerService.validator(event.target.files[0], this.fileOption)
    ) {
      item.file = event.target.files[0];
      this.documentRequiredValidation();
    }
  }

  getNIGODocuments(claimEntryId: number) {
    this.fileExtends = [];
    this.ppoService
      .getRequireNigoDocuments(claimEntryId)
      .subscribe(
        res => {
          if (res) {
            res.forEach(item => {
              this.fileExtends.push({
                documentId: item.documentTypeId,
                docName: item.documentName,
                file: null,
                acctptedTypes: "",
                index: 1,
                isOptional: item.isOptional
              });
            });

            this.documentRequiredValidation();
          }

        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  documentRequiredValidation() {
    //As All documents are mandatory. So check the number of required document and number of uploaded documents
    let rerquiredfile = 0;
    this.fileExtends.forEach(ele => {
      if (!ele.isOptional) {
        rerquiredfile++;
      }
    });
    let uploadedFile = 0;
    this.fileExtends.forEach(x => {
      if (x.file != null && !x.isOptional) {
        uploadedFile++;
      }
    });

    if (rerquiredfile === uploadedFile) {
      this.isDocSubmission = false;
    } else {
      this.isDocSubmission = true;
    }
  }

  submit() {
    this.messageService.confirm('Are you sure you want to submit?', false).then(result => {
      if (result.value) {
        this.statusId = PPORequestStatus.Submitted;
        this.submitOnlineClaimSubmission();

        this.navigationService.toPpoRequestList();
      }
      else {
        this.navigationService.toPpoRequestList();
      }
    })
  }

  submitOnlineClaimSubmission() {

    const data = this.getAdditionalDocumentData();

    this.groupClaimSubmissionService
        .ppoAdditionalDocumentSubmission(data)
        .subscribe(
          (res) => {
            this.resetFormSetting();
            this.messageService.show(
              this.customMessage.additionalSubmissionCommonMessage,
              "success"
            );
          },
          (err) => {
            this.messageService.show(err.error.message, "error");
          }
        );
  }

  getAdditionalDocumentData() {
    let entity = {
      claimEntryId: this.claimEntryId,
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      ppoRequestId: this.ppoRequestId,
    }
    const formData = this.getFormData(entity);
    return formData;
  }

  getFormData(data: any): FormData {
    let tempFileExtends = [...this.fileExtends];

    const formData = new FormData();
    formData.append("model", JSON.stringify(data));
    let additionalId: number = 0;
    tempFileExtends.forEach(x => {
      if (x.index != 0) {
        if (tempFileExtends.filter(f => f.documentId == x.documentId).length > 1)
          additionalId++;
      }
      formData.append(
        x.documentId.toString() + "-" + additionalId.toString(),
        x.file
      )
    });
    return formData;
  }

  resetFormSetting() {
    this.fileExtends = [];
    this.fileExtend = null;
    this.isDocSubmission = true;
  }

  getFileExtension() {
    this.fileValidatorService
      .getByValidatorType(ValidatorType.GroupClaimSubmission)
      .subscribe(
        res => {
          this.fileOption.validators = res;
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  viewDocument(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  clearUpload(item) {
    item.file = null;
    this.documentRequiredValidation();
    this.fileInputVariable.nativeElement.value = "";
  }

  addDocument(item: IFileExtend) {
    let indx = 0;
    const obj = this.fileExtends.filter(x => x.documentId === item.documentId);
    obj.forEach(element => {
      if (element.index > indx) {
        indx = element.index;
      }
    });

    this.fileExtends.push({
      documentId: item.documentId,
      docName: item.docName,
      file: null,
      acctptedTypes: "",
      index: indx + 1,
      isOptional: item.isOptional
    });

    this.fileExtends = this.fileExtends.sort((t1, t2) => {
      if (t1.documentId > t2.documentId) {
        return 1;
      }
      if (t1.documentId < t2.documentId) {
        return -1;
      }
      return 0;
    });
    this.documentRequiredValidation();
  }

  removeDocument(item: IFileExtend) {
    this.fileExtends = this.fileExtends.filter(x => x !== item);
    this.documentRequiredValidation();
  }

  cancel() {
    this.navigationService.toPpoRequestList();
  }

}

